export class Resource {
  id = '';
  loading = false;
  selected = false;
  classes = '';
  updatedDescription = '';
  disabled = false;
}
